import { render, staticRenderFns } from "./editPhone.vue?vue&type=template&id=cbbefe04&scoped=true"
import script from "./editPhone.vue?vue&type=script&lang=js"
export * from "./editPhone.vue?vue&type=script&lang=js"
import style0 from "./editPhone.vue?vue&type=style&index=0&id=cbbefe04&lang=scss&scoped=true"
import style1 from "./editPhone.vue?vue&type=style&index=1&id=cbbefe04&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbefe04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbbefe04')) {
      api.createRecord('cbbefe04', component.options)
    } else {
      api.reload('cbbefe04', component.options)
    }
    module.hot.accept("./editPhone.vue?vue&type=template&id=cbbefe04&scoped=true", function () {
      api.rerender('cbbefe04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/accountManage/components/editPhone.vue"
export default component.exports